import { Message } from 'element-ui'

let HxMessage = {
  success (message) {
    Message.success({
      showClose: true,
      message: message,
      type: 'success'
    })
  },

  warning (message) {
    Message.warning({
      showClose: true,
      message: message,
      type: 'warning'
    })
  },

  info (message) {
    Message.warning({
      showClose: true,
      message: message,
      type: 'info'
    })
  },

  error (message) {
    Message.warning({
      showClose: true,
      message: message,
      type: 'error'
    })
  }
}

export default HxMessage
